'use client'

import { Sales } from '@/screens/Sales'

import { SalesItemTypes } from '@/entities/sales'

import { PaginationProvider } from '@/shared/providers/PaginationProvider/paginationProvider'
import { TProduct } from '@/shared/types/product-types'

type SalesData = {
	ITEMS: SalesItemTypes[]
	productList?: TProduct[]
	push?: boolean
	TOTAL?: number
	PER_PAGE?: number
	CURRENT_PAGE?: number
	LAST_PAGE?: number
}

type Props = {
	promotions: SalesData
}

const SalesPageContent = ({ promotions }: { promotions: SalesData }) => {
	const { LAST_PAGE, CURRENT_PAGE, TOTAL, ITEMS } = promotions

	return (
		<>
			<PaginationProvider totalProducts={TOTAL} currentPage={CURRENT_PAGE} lastPage={LAST_PAGE}>
				<Sales ITEMS={ITEMS} />
			</PaginationProvider>
		</>
	)
}

export function SalesClient({ promotions }: Props) {
	return <SalesPageContent promotions={promotions} />
}
